import { Copy } from '@honda-canada/design-system-react';
import React from 'react';
import { compiler } from 'markdown-to-jsx';
import Link from '../../RoutableSitecoreLink';
import themeStyles from '../styles/Card.styles';
const TitleNavLink = themeStyles.apply(Link, 'CardLink');
const TitleNav = themeStyles.apply(Copy, 'CardLink');
const TitleCopy = themeStyles.apply(Copy, 'TitleCopy');
const Title = (props) => {
    const { alignment = 'center', title, styles, cta } = props;
    if (title === undefined)
        return null;
    const { href, linktype, target, label, gtmEvent, params } = cta || {};
    const searchParams = new URLSearchParams(params);
    const TitleNavWrapper = href ? TitleNavLink : TitleNav;
    return (React.createElement(TitleNavWrapper, { field: {
            value: {
                linktype,
                href,
                target,
                querystring: searchParams,
            },
        }, ariaLabel: label, "data-testid": "cy-uni-card-title", onClick: gtmEvent },
        React.createElement(TitleCopy, { as: "span", tabindex: "0", styles: styles, alignment: alignment }, compiler(title))));
};
export default Title;
